<template>
  <div class="control-stock-datos">
    <b-row>
      <b-col cols="12" xl="12">  
        <b-card header="Información del Control de Stock">
          <b-form-group
            label="Fecha"
            label-for="fechaRegistro"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaRegistro"
              :value="fechaRegistro | fechaHora" 
              readonly>
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Fecha Finalización"
            label-for="fechaFinalizacion"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="fechaFinalizacion"
              :value="fechaFinalizacion | fechaHora" 
              readonly>
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Usuario"
            label-for="usuario"
            :label-cols="labelCols"
            horizontal>
            <b-form-input 
              id="usuario"
              :value="usuario" 
              readonly>
            </b-form-input>
          </b-form-group>

          <b-form-group
            label="Observaciones"
            label-for="observaciones"
            :label-cols="labelCols"
            horizontal>
            <b-form-textarea
              id="observaciones"
              :value="observaciones"
              rows="3"
              max-rows="6"
              readonly>
            </b-form-textarea>
          </b-form-group>
        </b-card>

        <b-card header="Artículos">
          <b-table 
              small 
              responsive="sm" 
              class="registro-ordenes"
              :items="renglonesDatos" 
              :fields="fieldsRenglones">
            <template v-slot:cell(cantidadAjustada)="data">
              {{ data.item.cantidadAjustada ? 'Si' : 'No' }}
            </template>
          </b-table>
        </b-card>
      </b-col>
    </b-row>
    <div class="fixed-btn">
      <div class="list-dropdown-btn">
        <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
          <template slot="button-content">
            <i class="fa fa-ellipsis-v fa-2x" aria-hidden="true"></i>
          </template>
          
          <b-dropdown-item 
              @click.stop="goBack">
            <i class="fa fa-undo"></i>Volver al Listado</b-dropdown-item>
        </b-dropdown>
      </div>
    </div>

    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import moment from 'moment';
import { createHelpers } from 'vuex-map-fields';

const { mapFields } = createHelpers({
  getterType: 'controlStock/getField',
  mutationType: 'controlStock/updateField',
});

export default {
  name: 'ControlStockData',
  components: {
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data: () => {
    return {
      controlStockId: 0,

      fieldsRenglones: [
        {
          key: 'detailShowing',
          label: '',
          class: 'text-center'
        },
        {
          key: 'articulo',
        },
        { 
          key: 'cantidadStock',
          class: 'text-right' 
        },
        { 
          key: 'cantidadControl',
          class: 'text-right'   
        },
        { 
          key: 'cantidadAjustada',
          label: 'Ajustado',
          class: 'text-center' 
        }
      ],

      tableBusy: false,
      labelCols: 2
    }
  },
  created() {
    this.controlStockId = this.$route.params.id;

    this.showSpinner();
    this.$store.dispatch('controlStock/getDatos', this.controlStockId)
      .catch(error => this.showErrorMsj(error))
      .finally(() => this.hideSpinner());
  },  
  computed: {
    ...mapFields([
      'controlStockDatos',
      'renglonesDatos'
    ]),
    fechaRegistro() {
      if (this.controlStockDatos) {
        if (this.controlStockDatos.fechaRegistro) {
          return this.controlStockDatos.fechaRegistro;
        }
      }
      return '1900-01-01';
    },
    fechaFinalizacion() {
      if (this.controlStockDatos) {
        if (this.controlStockDatos.fechaFinalizacion) {
          return this.controlStockDatos.fechaFinalizacion;
        }
      }
      return '1900-01-01';
    },
    usuario() {
      if (this.controlStockDatos) {
        if (this.controlStockDatos.usuario) {
          return this.controlStockDatos.usuario.trim();
        }
      }
      return '';
    },
    observaciones() {
      if (this.controlStockDatos) {
        if (this.controlStockDatos.observaciones) {
          return this.controlStockDatos.observaciones.trim();
        }
      }
      return '';
    },
  },
  methods: {
    goBack() {
      this.$router.go(-1);
    },
  }
}
</script>

<style>
  .control-stock-datos .registro-ordenes table td {
    vertical-align: middle;
    border: none;
  }
  /* .control-stock-datos .registro-ordenes table td[aria-colindex="1"] {
    width: 3%;
  } */
</style>
